import "./notificationsStub.js";


// WEBPACK FOOTER //
// ./src/pages/notificationAlerts/index.js